import { useSearchParams } from "react-router-dom";
import { useAssetDetailsContext } from "../../context/assetDetailsContext";

export const useHandleTables = () => {
	const { state } = useAssetDetailsContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const handleAssetsTable = () => {
		if (state.assetsTable) {
			searchParams.set("statistics", "false");
			searchParams.set("workOrders", "false");
			setSearchParams(searchParams, { replace: true });
		} else searchParams.set("assets", "true");
		setSearchParams(searchParams, { replace: true });
	};

	const handleStatisticsTable = () => {
		if (state.statisticsTable) {
			searchParams.set("assets", "false");
			searchParams.set("workOrders", "false");
			setSearchParams(searchParams, { replace: true });
		} else searchParams.set("statistics", "true");
		setSearchParams(searchParams, { replace: true });
	};

	const handleWorkOrdersTable = () => {
		if (state.workOrdersTable) {
			searchParams.set("statistics", "false");
			searchParams.set("assets", "false");
			setSearchParams(searchParams, { replace: true });
		} else searchParams.set("workOrders", "true");
		setSearchParams(searchParams, { replace: true });
	};
	return [handleAssetsTable, handleStatisticsTable, handleWorkOrdersTable];
};
